import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

type ItemProps = {
    icon: LucideIcon;
    title: ReactNode;
    value: number;
};

function Item({ icon: Icon, title, value }: ItemProps) {
    return (
        <div className="tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-rounded-lg tw-border tw-bg-white">
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                <span className="tw-text-sm tw-font-medium tw-text-gray-500">{title}</span>
                <div className="tw-flex tw-items-center tw-justify-center tw-size-8 tw-rounded-md tw-bg-gray-100 tw-text-gray-600">
                    <Icon className="tw-size-4 tw-text-primary" />
                </div>
            </div>

            <span className="tw-text-2xl tw-font-semibold tw-text-gray-900">{value}</span>
        </div>
    );
}

export default Item;
